import * as tslib_1 from "tslib";
import { Component, } from 'vue-property-decorator';
import { TextInputControl } from '@cloudpivot/form/src/common/controls/input-controls/text-input-control';
import * as typings from '@cloudpivot/form/schema';
let InputTextarea = class InputTextarea extends TextInputControl {
    constructor() {
        super(...arguments);
        // @Prop({
        // 	default: TextAreaType.LongText
        // })
        // type! :TextAreaType
        this.renderComponent = true;
    }
    forceRerender() {
        // 从 DOM 中删除 组件
        this.renderComponent = false;
        let chArr = document.body.getElementsByClassName('ke-container');
        for (let i = 0; i < chArr.length; i++) {
            if (chArr[i] != null)
                chArr[i].parentNode.removeChild(chArr[i]);
        }
        this.$nextTick(() => {
            // 在 DOM 中添加 组件
            this.renderComponent = true;
        });
    }
    mounted() {
        typings.EventBus.$on('activeKey', ({ data: any }) => {
            this.forceRerender();
        });
    }
    onChange() {
        const val = this.val.length === 0 ? null : this.val;
        this.setValue(val);
    }
};
InputTextarea = tslib_1.__decorate([
    Component({
        name: 'input-textarea',
        components: {
            H3Textarea: () => import('../h3-textarea.vue'),
            H3Editor: () => import(/* webpackChunkName: "h3-editor" */ './h3-editor.vue'),
        },
    })
], InputTextarea);
export default InputTextarea;
